import { Check } from 'lucide-react';

export const AVATARS = [
  { id: 'knight', emoji: '🛡️', label: 'Knight' },
  { id: 'wizard', emoji: '🧙', label: 'Wizard' },
  { id: 'ninja', emoji: '🥷', label: 'Ninja' },
  { id: 'robot', emoji: '🤖', label: 'Robot' },
  { id: 'alien', emoji: '👾', label: 'Alien' },
  { id: 'dragon', emoji: '🐉', label: 'Dragon' },
  { id: 'ghost', emoji: '👻', label: 'Ghost' },
  { id: 'fox', emoji: '🦊', label: 'Fox' },
  { id: 'cat', emoji: '🐱', label: 'Cat' },
  { id: 'wolf', emoji: '🐺', label: 'Wolf' },
  { id: 'eagle', emoji: '🦅', label: 'Eagle' },
  { id: 'fire', emoji: '🔥', label: 'Fire' },
  { id: 'star', emoji: '⭐', label: 'Star' },
  { id: 'crown', emoji: '👑', label: 'Crown' },
  { id: 'skull', emoji: '💀', label: 'Skull' },
  { id: 'gem', emoji: '💎', label: 'Gem' },
];

export function getAvatarById(id: string | null | undefined) {
  return AVATARS.find(a => a.id === id) || null;
}

interface AvatarPickerProps {
  selectedId: string | null;
  onSelect: (id: string) => void;
  columns?: number;
}

export default function AvatarPicker({ selectedId, onSelect, columns = 8 }: AvatarPickerProps) {
  return (
    <div className={`grid gap-2`} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
      {AVATARS.map((avatar) => (
        <button
          key={avatar.id}
          type="button"
          onClick={() => onSelect(avatar.id)}
          className={`relative w-12 h-12 rounded-lg flex items-center justify-center text-2xl transition hover:bg-white/10 ${
            selectedId === avatar.id ? 'bg-pink-500/20 ring-2 ring-pink-500' : 'bg-white/5'
          }`}
          title={avatar.label}
        >
          {avatar.emoji}
          {selectedId === avatar.id && (
            <Check className="absolute -top-1 -right-1 w-4 h-4 text-pink-500 bg-slate-800 rounded-full" />
          )}
        </button>
      ))}
    </div>
  );
}
